const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="u-clearfix u-border-medium u-pad-1">
  <div class="u-border-medium u-pad-1 u-size-inline-1/2" style="float: right;">I’m floating!</div>
</div>
`);
            }

            getTemplateName() {
                return `aaa2b84692c2370cc8f4fc664ec1442940be5438a1c70d44338b42c8ae1a567b`;
            }

            getSourceContext() {
                return new this.Source(``, `aaa2b84692c2370cc8f4fc664ec1442940be5438a1c70d44338b42c8ae1a567b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'aaa2b84692c2370cc8f4fc664ec1442940be5438a1c70d44338b42c8ae1a567b');

let template = env.loadTemplate('aaa2b84692c2370cc8f4fc664ec1442940be5438a1c70d44338b42c8ae1a567b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/display/demo/clearfix.twig", args: context }
     );
     return rendered;;
};